import {Checkbox, FormControl, Grid2 as Grid} from "@mui/material";
import React from "react";

interface FormAggregationProps {
  name: string;
  label: string;
  values?: Record<string, boolean>;
  value?: boolean;
  children: React.ReactNode;
  onChange?: (name: string, value: boolean) => void;
}

export default function FormAggregation({
  name,
  label,
  values = {},
  value,
  children,
  onChange = () => {
  }
}: FormAggregationProps) {
  return <Grid container justifyContent="center" alignItems="center" wrap={"nowrap"} size={12}>
    {children}
    <Grid size={1}>
      <FormControl fullWidth>
        <Checkbox
          name={"aggregateBy_" + name}
          data-testid={"aggregateBy_" + name}
          checked={values[name] ?? value ?? false}
          onChange={e => onChange(name, e.target.checked)}
          size={"medium"}
          title={label}
          aria-label={label} />
      </FormControl>
    </Grid>
  </Grid>;
}
